<template>
  <div class="fileContainer">
    <div class="fileTitle">律师入驻服务协议</div>
    <div class="filePart">
      <div>欢迎您使用本平台律师入驻服务。在您确认接受本协议并完成入驻流程前，请您务必仔细阅读、充分理解各条款内容，特别是以加粗或下划线形式标注的免责、限制责任及争议解决条款。当您勾选"我已阅读并同意"或以任何方式确认接受本协议，即视为您已充分理解并同意接受本协议全部内容，本协议即对您产生法律约束力。</div>
    </div>
    <div class="filePart">
      <div class="fileMenu">第一章 定义与解释</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第一条 术语定义</div>
        <div>除本协议另有约定外，下列词语具有以下含义：</div>
        <p>• 本平台：指为群众提供公共法律服务的平台，包括热线平台、网站、移动客户端、小程序及相关服务系统。</p>
        <p>• 入驻服务：指平台运营方提供的用于开展公共法律咨询服务的在线信息展示、用户咨询解答、服务记录管理等技术支持与运营支持。</p>
        <p>• 律师主页：指入驻后在本平台展示的个人信息页面，包括但不限于执业信息、专业领域、服务介绍、评价等。</p>
        <p>• 法律服务：指通过本平台向用户免费提供的法律咨询、法律意见等非营利性专业法律服务。</p>
        <p>• 平台用户：指通过本平台注册、浏览或使用相关服务并寻求法律服务的自然人、法人或非法人组织。</p>
        <p>• 平台规则：指平台运营方制定并公示的与本平台运营相关的各项规则、规范、指引、公告及通知，构成本协议不可分割的组成部分。</p>
      </div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第二条 职责边界</div>
        <div>平台运营方职责：负责平台运营维护、技术支持、资质审核、用户需求对接、服务记录管理及平台规则制定，不介入您提供法律咨询的具体内容，不对您的专业判断作实质性干预。</div>
        <div>您的职责：以自身专业律师身份独立、依法提供公共法律咨询，对服务质量及服务行为负责，遵守法律法规、律师行业规范及平台规则，不得利用平台从事商业活动。</div>
        <div>双方确认：平台运营方提供技术支持与运营服务，您独立开展法律咨询服务并承担相应责任；平台运营方仅对自身故意或重大过失造成的直接损失承担责任，因您服务质量引发的责任由您及所在律师事务所依法承担。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第二章 入驻申请与审核</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第三条 入驻条件</div>
        <div>申请入驻本平台，应同时满足以下条件：</div>
        <p>• 持有中华人民共和国司法行政机关颁发的、处于有效执业状态的《律师执业证》；</p>
        <p>• 在依法设立的律师事务所或法律服务机构执业，且执业关系清晰、无执业冲突；</p>
        <p>• 具备良好的职业操守，近三年内未受过司法行政机关行政处罚或律师协会行业处分（情节轻微且已改正的除外）；</p>
        <p>• 能够独立承担民事责任，具备完全民事行为能力；</p>
        <p>• 愿意为群众提供公共法律服务，遵守本协议及平台规则。</p>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第四条 入驻流程</div>
        <div>应按照本平台入驻流程，如实填写个人信息并提交相关资质材料，包括但不限于：身份证件、律师执业证、执业机构证明、本人手持证件照片等。平台运营方有权对您提交的信息及材料进行审核，并可根据需要要求您补充提供其他证明文件。</div>
        <div>平台运营方将在收到完整申请材料后的合理期限内完成审核。审核通过的，平台运营方将为您开通律师主页及相关服务权限；审核未通过的，平台运营方应说明理由，您有权在合理期限内申诉或补充材料。平台运营方亦有权在入驻后根据实际情况调整您的服务权限。</div>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第五条 信息真实性承诺</div>
        <div>承诺所提交的全部信息及材料均真实、准确、完整、有效，不存在任何虚假、误导或遗漏。如信息发生变更（包括但不限于执业机构变更、执业证年检状态变化、联系方式变更等），应在变更之日起七个工作日内通过本平台予以更新或书面告知平台运营方。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第三章 服务内容与权限</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第六条 服务内容与性质</div>
        <div>平台运营方为您提供以下服务：</div>
        <p>• 在本平台为您创建并维护律师主页，展示您的执业信息及专业能力；</p>
        <p>• 提供热线法律咨询、在线法律咨询、即时沟通等技术支持和服务通道；</p>
        <p>• 提供平台用户需求对接及匹配服务；</p>
        <p>• 提供服务记录管理、服务时长统计等服务支持；</p>
        <p>• 提供平台运营支持及必要的培训指导。</p>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第四章 权利与义务</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第七条 您的权利</div>
        <p>• 依法依约使用本平台提供的服务工具及功能；</p>
        <p>• 对平台运营方提供的服务提出意见、建议或投诉；</p>
        <p>• 获得平台提供的服务时长记录、服务证明等支持；</p>
        <p>• 依法享有执业过程中的人格权、个人信息保护等合法权利。</p>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第八条 您的义务</div>
        <div>在使用本平台服务过程中，应严格遵守以下义务：</div>
        <p>• 合法执业：严格遵守《中华人民共和国律师法》及相关法律法规、律师行业规范，依法合规提供法律服务，遵守司法行政机关关于线上法律服务的现行规定，不得超出执业范围从事法律服务活动；</p>
        <p>• 勤勉尽责：以专业、审慎、勤勉的态度对待每一位服务对象，保障服务质量，维护群众合法权益；</p>
        <p>• 信息保密：对在服务过程中获悉的平台用户隐私信息、案件信息及商业秘密予以严格保密，不得泄露、出售或非法提供给第三方；</p>
        <p>• 利益冲突审查：在提供服务前应自行进行利益冲突审查。如发现存在利益冲突情形，应主动回避并及时告知相关方；</p>
        <p>• 独立承担责任：因您的服务行为产生的法律责任，由您及您所在律师事务所依法承担；您所在律师事务所对外承担责任后，可依法向有故意或者重大过失行为的乙方追偿；</p>
        <p>• 账号安全：妥善保管本平台账号及密码，不得出借、转让或共享给他人使用。因账号保管不当导致的一切后果由您自行承担。</p>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第九条 禁止行为</div>
        <div>不得从事以下行为：</div>
        <p>• 发布损害国家利益、危害国家安全、破坏民族团结、违反国家法律法规和政策的言论，或利用本平台从事与公益法律服务无关的政治性讨论；</p>
        <p>• 发布虚假、夸大、误导性信息或对服务效果作出不当承诺；</p>
        <p>• 以不正当方式获取案源，包括但不限于虚假宣传、恶意竞争、商业贿赂等；</p>
        <p>• 向用户收取费用、变相收费，或诱导用户脱离平台进行有偿交易；</p>
        <p>• 发布违反法律法规、公序良俗或本平台规则的内容；</p>
        <p>• 冒用其他律师身份或伪造、变造执业资质材料；</p>
        <p>• 对平台用户进行骚扰、威胁、恐吓或其他侵害其合法权益的行为；</p>
        <p>• 利用本平台从事损害平台公益性质或社会公共利益的活动。</p>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第五章 平台运营方的权利与义务</div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第十条 平台运营方的权利</div>
        <p>• 对您提交的信息及材料进行审核，并有权要求补充或更正；</p>
        <p>• 制定、修改平台规则，并对平台运营进行管理；</p>
        <p>• 对您的服务行为进行监督，如发现您违反本协议或平台规则，有权采取警告、限制功能、暂停服务、下架内容、关闭账号等措施；</p>
        <p>• 在合理且必要的范围内，对律师信息展示内容进行编辑、调整或删除；</p>
        <p>• 根据法律法规要求或有权机关指令，配合提供相关信息或采取相应措施。</p>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第十一条 平台运营方的义务</div>
        <p>• 为您提供稳定、安全的平台技术环境及服务支持；</p>
        <p>• 依法保护您及平台用户的个人信息与隐私；</p>
        <p>• 对您提交的非公开信息予以保密，法律法规另有规定或您同意的除外；</p>
        <p>• 及时处理您提出的问题、建议及投诉；</p>
        <p>• 不得将您的个人信息用于公益服务以外的商业目的。</p>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第十二条 免责声明</div>
        <div>平台运营方在以下情形下不承担责任：</div>
        <p>• 因您提供的法律咨询内容、服务行为引发任何第三方纠纷、索赔或诉讼的，由您及所在律师事务所依法承担法律责任。若平台因此遭受损失或对外先行赔付的，平台有权向您及所在律所追偿；</p>
        <p>• 因不可抗力、系统维护、网络故障等非平台运营方过错原因导致的服务中断或异常；</p>
        <p>• 因您违反法律法规或本协议约定而产生的任何后果；</p>
        <p>• 平台运营方已尽合理注意义务仍无法避免的情形。</p>
        <div>平台运营方仅对自身故意或重大过失造成的直接损失承担责任，不免除依法应承担的法定责任。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第六章 公益服务原则</div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第十三条 公益服务原则</div>
        <div>本平台免费为群众提供法律咨询服务，是公益性质的公共法律服务平台。您通过本平台提供的法律咨询均为公益服务，不得向用户收取任何费用或要求用户支付任何形式的报酬。平台运营方不向您收取平台服务费、管理费或任何入驻费用。</div>
        <div>您不得在平台页面展示或宣传任何收费项目、商业广告，不得以任何方式引导用户进行有偿委托，不得利用平台获取的用户信息从事商业活动。如用户有代理、辩护等有偿法律服务需求，应通过合法途径自主选择，您不得利用本平台信息主动招揽。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第七章 知识产权与信息使用</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第十四条 知识产权与信息使用</div>
        <div>本平台的域名、标识、页面设计、软件程序、数据库及其他相关知识产权均归平台运营方或其权利人所有，未经平台运营方书面许可，您不得擅自使用、复制或传播。</div>
        <div>您仅向平台提供个人基本信息及执业信息用于本平台公益服务展示。您对个人基本信息及执业信息依法享有合法权益，平台运营方仅可在本协议约定的公益服务范围内使用，不得用于其他商业目的。 您同意平台运营方在公共咨询服务范围内使用您的执业信息（包括姓名、执业证号、执业机构、专业领域、执业年限等）用于平台展示与运营。平台运营方在使用您的信息时，应遵守相关个人信息保护法律法规，不得超出公益服务目的使用。您有权随时撤回同意，并要求平台运营方更正或删除不准确的展示信息；平台运营方应在收到请求后合理期限内予以处理。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第八章 保密条款</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第十五条 保密义务</div>
        <div>双方对于在履行本协议过程中获悉的对方非公开信息，包括但不限于商业秘密、技术信息、运营数据、用户信息等，均负有保密义务。未经对方书面同意，不得向第三方披露。保密义务在本协议终止后仍持续有效，期限为协议终止后五年；对于用户个人信息及敏感个人信息，保密义务在法律法规规定的保存期限内持续有效。</div>
        <div>以下情形不构成违反保密义务：根据法律法规规定或有权机关要求进行的披露；信息已进入公众领域且非因一方违约导致；一方自行开发或合法获取的同类信息。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第九章 违约责任</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第十六条 违约责任</div>
        <div class="filePartTitle">（一）您方违约</div>
        <div>您违反本协议或平台规则的，平台运营方有权根据情节轻重采取以下一项或多项措施：书面警告、限制部分功能、暂停服务、隐藏或删除违规内容、暂时封禁账号、永久关闭账号、取消入驻资格。如您的违约行为给平台运营方或平台用户造成损失的，您应承担全部赔偿责任。</div>
        <div class="filePartTitle">（二）平台运营方违约</div>
        <div>平台运营方未按约定提供服务的，应采取合理措施及时予以补救。因平台运营方重大过失或故意行为给您造成直接经济损失的，平台运营方应承担相应赔偿责任。</div>
        <div class="filePartTitle">（三）连带追偿</div>
        <div>因您在平台上的行为导致平台运营方遭受第三方索赔或其他损失的，您应负责解决并赔偿平台运营方因此遭受的直接损失及合理维权费用，包括但不限于赔偿金、诉讼费、律师费、公证费等。因您故意或重大过失直接导致平台运营方受到行政处罚的，平台运营方有权就该等处罚金额向您追偿。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第十章 协议变更、终止与退出</div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第十七条 协议变更</div>
        <div>平台运营方有权根据法律法规变化及平台运营需要修改本协议及相关规则，修改内容将在本平台公示。一般修改自公示之日起生效；涉及加重您的责任、限制您主要权利等重大变更的，平台运营方将以显著方式单独提示并要求您重新确认，您不同意的有权停止使用并按本协议约定申请退出，平台运营方应妥善处理未完结服务事项。如您在修改生效后继续使用本平台服务，视为接受修改后的协议。</div>
      </div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第十八条 协议终止与退出</div>
        <div class="filePartTitle">（一）终止情形</div>
        <div>出现以下情形之一的，本协议终止：</div>
        <p>• 主动申请退出，并完成相关手续的；</p>
        <p>• 律师执业证失效、被吊销或注销的；</p>
        <p>• 丧失民事行为能力或死亡的；</p>
        <p>• 严重违反本协议或平台规则，平台运营方依约终止服务的；</p>
        <p>• 因不可抗力或其他客观原因导致本协议无法继续履行的；</p>
        <p>• 法律法规规定或本协议约定的其他终止情形。</p>
        <div class="filePartTitle">（二）退出机制</div>
        <div>您申请退出的，应提前书面通知平台运营方，并妥善处理未完结的服务事项。平台运营方应在您完成相关清理义务后合理期限内关闭其账号及服务权限。您退出后，平台运营方应在30日内删除或匿名化处理您的个人信息，但法律法规要求留存或双方另有约定的除外；您可要求平台运营方导出您的个人信息。</div>
        <div class="filePartTitle">（三）终止后义务</div>
        <div>本协议终止后，您应立即停止使用本平台服务，并仍需履行以下义务：对协议存续期间获悉的信息继续承担保密义务；对未完结的服务事项继续履行至完成；对协议存续期间的违约行为承担相应责任。</div>
      </div>
    </div>

    <div class="filePart">
      <div class="fileMenu">第十一章 争议解决</div>
      <div class="fileSubMenu">第十九条 争议解决方式</div>
      <div>本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权向平台运营方住所地有管辖权的人民法院提起诉讼。</div>
    </div>

    <div class="filePart">
      <div class="fileSMenu">第十二章 附则</div>

      <div class="fileSubPart">
        <div class="fileSubMenu">第二十条 通知与送达</div>
        <div>平台运营方可以通过本平台站内信、电子邮件、短信或其他电子方式向您发送通知，通知自到达您的系统之日视为送达；发出后满24小时未提出异议的，视为已送达。涉及账号关闭、终止协议等重大事项的，平台运营方应采用两种以上方式通知，并提前合理期限告知。您变更联系方式未及时更新的，自行承担由此产生的不利后果。</div>
      </div>
      <div class="fileSubPart">
        <div class="fileSubMenu">第二十一条 附则</div>
        <div>本协议任何条款被认定为无效或不可执行的，不影响其他条款的效力，双方应协商以有效且经济意图最接近的条款予以替代。</div>
        <div>本协议连同平台规则、费用说明等文件构成双方就入驻事项的完整协议，取代双方此前就同一事项作出的任何口头或书面约定。</div>
        <div>本协议以电子形式订立，自您在线勾选"我已阅读并同意"之日起生效。本协议以数据电文形式存在，无需双方另行签字或盖章，与书面协议具有同等法律效力。</div>
      </div>
    </div>

    <div class="checkBox">
      <p>
        <Checkbox @on-change="changeValue" disabled v-model="checkBox">入驻确认声明</Checkbox>
      </p>
      <div>本人已仔细阅读并充分理解《律师入驻服务协议》全部内容，自愿接受并遵守本协议各项约定。本人确认所提交的入驻信息及资质材料均真实有效，本人将以合法、专业、诚信的方式使用本平台服务。本人自愿入驻，承诺以公益为先，遵守本协议及平台规则，不向用户收取任何费用或变相收费，不利用平台信息谋取商业利益。本人知悉并同意：本协议以电子形式订立，自本人在线勾选"我已阅读并同意"之日起生效，与手写签名或盖章具有同等法律效力，无需双方另行签署。</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checked: {
      required: false,
      default: false
    }
  },
  watch: {
    checked: {
      immediate: true,
      handler: function (val, valO) {
        this.checkBox = val
      }
    }
  },
  data () {
    return {
      checkBox: false
    }
  },
  methods: {
    changeValue: function (val) {
      this.checkBox = val
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="less" scoped>
.fileContainer {
  word-wrap: break-word;
  user-select: none;

  font-family: 'Microsoft YaHei', SimHei, sans-serif;
  max-width: 600px;
  margin: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 1rem;

  .fileTitle {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .filePre {
    margin: 10px 0;
  }

  .fileMenu {
    font-size: 1rem;
    font-weight: 600;
    line-height: 2rem;
    margin-bottom: 10px;
  }

  .fileSubMenu {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .filePart {
    margin: 10px 0;
    text-indent: 2rem;

    .fileSubPart > {
      margin-bottom: 1rem;

      > p,
      > div {
        margin-bottom: 10px;
      }
    }

    .filePartTitle {
      font-weight: 500;
      margin-bottom: 6px;
    }

    .filePartContent {
      // font-size: 0.9rem;
    }
  }

  .checkBox {
    background-color: #ecf6ff;
    border: 1px solid #84c7ff;
    padding: 10px;
    line-height: 1.4rem;

    > p {
      font-weight: 600;
      margin-bottom: 6px;
    }
  }
}
</style>